// extracted by mini-css-extract-plugin
module.exports = {"containerAnimation":"styles_containerAnimation__bR2Br","container":"styles_container__1vwWv","closeButton":"styles_closeButton__3xbGp","menuList":"styles_menuList__2elJz"};